import { useCallback, useEffect, useState } from "react";
import useTopicHandler from "../../../hooks/useTopicHandler";
import { useConfigsDataContext } from "../../../providers/ConfigsDataContextProvider";
import useQueueHandler from "../../../hooks/useQueueHandler";

/*
const {myData:keyCreatedErrorInfo,    teamData:keyCreatedData,     onMyMount:onMountKeyCreated,  onMyCleanup:onCleanupKeyCreated,  sendMsg:createKey}     = useWebSocketComm('create-config-key',   null, 'config-key-created',   'config-key-created',   false, null);
const {myData:keyRenamedErrorInfo,    teamData:progKeyRenamedData, onMyMount:onMountKeyRename,   onMyCleanup:onCleanupKeyRename,   sendMsg:renameKey}     = useWebSocketComm('rename-config-key',   null, 'config-key-renamed',   'config-key-renamed',   false, null);
const {myData:keyDeletedErrorInfo,    teamData:keyDeletedData,     onMyMount:onMountKeyDeleted,  onMyCleanup:onCleanupKeyDeleted,  sendMsg:deleteProgKey} = useWebSocketComm('delete-config-key',   null, 'config-key-deleted',   'config-key-deleted',   false, null);
const {myData:valUpdatedErrorInfo,    teamData:valUpdatedData,     onMyMount:onMountValUpdated,  onMyCleanup:onCleanupValUpdated,  sendMsg:updateVal}     = useWebSocketComm('update-config-val',   null, 'config-val-updated',   'config-val-updated',   false, null);
const {myData:titleUpdatedErrorInfo,  teamData:titleUpdatedData,   onMyMount:onMountTitleUpdated,onMyCleanup:onCleanupTitleUpdated,sendMsg:updateTitle}   = useWebSocketComm('update-config-title', null, 'config-title-updated', 'config-title-updated', false, null);
*/

// --------[   use Item Listener   ]-----------
//
// Item Fields:
//  - progKey :  The config property name used in the consuming Java Application code.
//  - value   :  The value of the config property.
//  - title   :  A free text to name the config property in a more human readable way.
//  - note    :  A free text to describe the purpose of the config property and special developers notes about it.
// Field States:
//          - No special state - the value is valid and display normally.
//          - Error: The field's kInfo holds a server error info for display. this switch the field to edit mode in order to correct.
//          - Lock: The field's kInfo holds a flag indicating if the field should be visualized as locked for edit or not.
//          - InProgress: Indicates a "Save" for the field content has been submitted to visualize if it takes longer then usual. (this might not have time to visualize when network is optimal)
//          - JustUpdated: Flag to visualize the content of the field has been updated
export default function useItemListener() {
  //console.log('[useItemListener] Enter');
  
  //const {configPath}                    = useConfigPathContext();

  const { createConfigItem, tagKeyCreatedError, resetKeyCreatedError, setCreateKeyInProgress, 
          setKeyLocked, setKeyEditing, renameConfigKey, tagKeyRenamedError, deleteConfigKey, tagKeyDeletedError, resetKeyKInfo,
          updateConfigVal,  setValueLocked, tagValueError,  setValueEditing, clearValKInfo, 
          updateTitle,      setTitleLocked, tagTitleError,  setTitleEditing, clearTitleKInfo,
    clearJustUpdated, saveItem, updateInsight, reasoning, setReasoning, insightRejected, setInsightRejected
          //updateNote,       setNoteLocked,  tagNoteError,   setNoteEditing,  clearNoteKInfo
                           }            = useConfigsDataContext();

  // Only Team Topic, the queue channel for private error message is handled by the originating component. E.g: CreateProgKey
  const {topicData:configKeyCreated}    = useTopicHandler('config-key-created');
  const {queueData:keyCreatedError}     = useQueueHandler('config-key-created');

  const {topicData:configKeyRenamed}    = useTopicHandler('config-key-renamed');
  const {queueData:keyRenamedError}     = useQueueHandler('config-key-renamed');

  const {topicData:configKeyDeleted}    = useTopicHandler('config-key-deleted');
  const {queueData:keyDeletedError}     = useQueueHandler('config-key-deleted');

  const {topicData:configValUpdated}    = useTopicHandler('config-val-updated');
  const {queueData:valUpdatedError}     = useQueueHandler('config-val-updated');

  const {topicData:configTitleUpdated}  = useTopicHandler('config-title-updated');
  const {queueData:titleUpdatedError}   = useQueueHandler('config-title-updated');
  
  // SDK Listeners
  const {topicData:sdkConfigItemSaved}  = useTopicHandler('config-prop-saved'); // TODO: Rename to sdk-config-item-saved
  const {queueData:sdkItemSavedError}   = useQueueHandler('config-prop-saved');
  
  // TODO: 
  //      - Per Item: Accept and Reject Buttons.
  //      - Per Folder: Dismiss the insight lines / Mark as read / Delete
  //const { topicData: insightData } = useTopicHandler('config-insight');
  const { queueData: insightData } = useQueueHandler('config-insight');  
  
  const [itemChanged, setItemChanged] = useState(Date.now());  

  const fireItemChanged = useCallback(()=> {
    // console.log('---[  fireItemChanged  ]---');    
    setItemChanged(Date.now());
  }, []);
  

  // TODO: config-note-updated  

  //------[   Clear ErrorKeyCreated   ]----------
  //
  const clearErrorKeyCreated = useCallback(async (keyCreatedError) => {
    return resetKeyCreatedError(keyCreatedError)
      .then(fireItemChanged);
  }, [resetKeyCreatedError, fireItemChanged]);

  //------[   Tag CreateKeyInProgress   ]-------
  //
  const tagCreateKeyInProgress = useCallback(async (folderPath, keyName) => {
    // console.log('[useItemListener tagCreateKeyInProgress] [folderPath: %s] [keyName: %s]', folderPath, keyName);
    
    return setCreateKeyInProgress(folderPath, keyName)
      .then(fireItemChanged);
  }, [setCreateKeyInProgress, fireItemChanged]);  

  //------[   Reset CreateKeyInProgress   ]-------
  //
  const resetCreateKeyInProgress = useCallback(async (folderPath) => {
    // console.log('[useItemListener resetCreateKeyInProgress] [folderPath: %s]', folderPath);
    
    return setCreateKeyInProgress(folderPath, null, false)
      .then(fireItemChanged);
  }, [setCreateKeyInProgress, fireItemChanged]);  
  

  // ------   Effect  Config Key Created   -----------
  //
  useEffect(()=>{
    if (configKeyCreated) {
      createConfigItem(configKeyCreated) // Create safely
        .then(fireItemChanged)    // See the created item in special "item updated" color effect. 
        .then(()=>clearJustUpdated(configKeyCreated.basePath, configKeyCreated.key))   // delay for a second and remove the special "item updated" color effect.
        .then(fireItemChanged)   // Back to normal colors.
        .then(()=> {
          window.gtag_report_conversion();
        })

    }
  }, [configKeyCreated, createConfigItem, fireItemChanged, clearJustUpdated]);


  //------[   Effect   KeyCreatedError   ]------
  //
  useEffect(()=>{
    if (keyCreatedError) {
      // console.log('[useItemListener Effect keyCreatedError] [keyName: %s]', keyCreatedError.newKey);
      tagKeyCreatedError(keyCreatedError)
        .then(fireItemChanged);
    }
  },[keyCreatedError, tagKeyCreatedError, fireItemChanged]);


  useEffect(()=>{
    if (configKeyRenamed) {
      renameConfigKey(configKeyRenamed)
        .then(fireItemChanged);
    }
  },[configKeyRenamed, renameConfigKey, fireItemChanged]);

  useEffect(()=>{
    if (keyRenamedError) {
      // console.log('[useItemListener Effect keyRenamedError] %s', JSON.stringify(keyRenamedError, null, 2));      
      tagKeyRenamedError(keyRenamedError)
        .then(fireItemChanged);
    }
  }, [keyRenamedError, tagKeyRenamedError, fireItemChanged]);


  useEffect(()=>{
    if (configKeyDeleted) {
      // console.log('[useItemListener Effect configKeyDeleted] %s', JSON.stringify(configKeyDeleted, null, 2));
      deleteConfigKey(configKeyDeleted)
        .then(fireItemChanged);
    }
  },[configKeyDeleted, deleteConfigKey, fireItemChanged]);

  useEffect(() => {
    console.log('[useItemListener] [Effect] [insightRejected: %s]', JSON.stringify(insightRejected, null, 2));

    if (insightRejected) {
      deleteConfigKey(insightRejected)
        .then(fireItemChanged)
    }

  }, [insightRejected, deleteConfigKey, fireItemChanged]);

  useEffect(()=>{
    if (keyDeletedError) {
      // console.log('[useItemListener Effect keyDeletedError] %s', JSON.stringify(keyDeletedError, null, 2));
      tagKeyDeletedError(keyDeletedError)
        .then(fireItemChanged);
    }
  }, [keyDeletedError, tagKeyDeletedError, fireItemChanged ]);

  
  // --- SDK Item Saved ---
  //
  useEffect(()=>{
    if (sdkConfigItemSaved) {
      saveItem(sdkConfigItemSaved)
        .then(fireItemChanged); // TODO: Make it with Special Colors to indicate an "Updated Item" 
        // .then( setTimeout --> remove `justDeleted` flag) // delay and return to normal colors 
        // .then( fireItemChanged ) // Refresh to show the normal colors
    }
  }, [sdkConfigItemSaved, saveItem, fireItemChanged]);

  // --- Add Insight Items ---
  useEffect(() => {
    if (insightData) {
      console.log('[useItemListener effect] insightData: %s', JSON.stringify(insightData, null, 2));
      setReasoning(false);
      updateInsight(insightData)
        .then(fireItemChanged)
    }
  }, [insightData, updateInsight, fireItemChanged, setReasoning]);


  // ------   Effect Config Val Updated   ------------
  //
  useEffect(()=>{
    if (configValUpdated) {
      updateConfigVal(configValUpdated)
        .then(fireItemChanged);   // Should be with special "Updated" color effect.
            // .then( setTimeout --> delete JustUpdated ) // Delay and return to normal colors.
            //  .then( fireItemChanged ) // Refresh to see the new one in normal colors.
    }
  }, [configValUpdated, updateConfigVal, fireItemChanged]);


  // Effect Title Updated
  // 
  useEffect(()=>{
    if (configTitleUpdated) {
      updateTitle(configTitleUpdated)
        .then(fireItemChanged);
    }
  }, [configTitleUpdated, updateTitle, fireItemChanged]);

  //------  Effect Val Updated Error   ------------
  //
  useEffect(()=>{
    if (valUpdatedError) {
      // console.log('[useItemListener Effect valUpdatedError] %s',JSON.stringify(valUpdatedError, null, 2));
      tagValueError(valUpdatedError)
        .then(fireItemChanged);
    }
  }, [valUpdatedError, tagValueError, fireItemChanged]);


  //---- Effect Title Error
  //
  useEffect(()=>{
    if (titleUpdatedError) {
      tagTitleError(titleUpdatedError)
         .then(fireItemChanged);
    }
  }, [titleUpdatedError, tagTitleError, fireItemChanged]);


  //------[   Tag Value Locked   ]-------
  //
  const tagValueLocked = useCallback(async (folderPath, keyName) => {
    // console.log('[useItemListener tagValueLocked] [folderPath: %s] [keyName: %s]', folderPath, keyName);    
    return setValueLocked(folderPath, keyName)
              .then(fireItemChanged);
  }, [setValueLocked, fireItemChanged]);

  const tagTitleLocked = useCallback(async (folderPath, keyName) => {
    // console.log('[useItemListener tagTitleLocked] [folderPath: %s] [keyName: %s]', folderPath, keyName);
    return setTitleLocked(folderPath, keyName)
              .then(fireItemChanged);
  }, [setTitleLocked, fireItemChanged]);

  const tagKeyLocked = useCallback(async (folderPath, keyName) => {
    // console.log('[useItemListener tagKeyLocked] [folderPath: %s] [keyName: %s]', folderPath, keyName);    
    return setKeyLocked(folderPath, keyName)
              .then(fireItemChanged);
  }, [setKeyLocked, fireItemChanged]);

  const resetKeyLocked = useCallback(async (folderPath, keyName) => {
    return setKeyLocked(folderPath, keyName, false)
              .then(fireItemChanged);
  }, [setKeyLocked, fireItemChanged]);

  const resetTitleLocked = useCallback(async (folderPath, keyName) => {
    return setTitleLocked(folderPath, keyName, false)
              .then(fireItemChanged);
  },[setTitleLocked, fireItemChanged]);

  //------[   Reset Value Locked   ]----------
  //
  const resetValueLocked = useCallback(async (folderPath, keyName) => {
    return setValueLocked(folderPath, keyName, false)
              .then(fireItemChanged);
  }, [setValueLocked, fireItemChanged]);

  const tagValueEditing = useCallback(async (folderPath, keyName) => {
    return setValueEditing(folderPath, keyName)
              .then(fireItemChanged);
  },[setValueEditing, fireItemChanged]);

  const tagTitleEditing = useCallback(async (folderPath, keyName) => {
    return setTitleEditing(folderPath, keyName)
              .then(fireItemChanged)    
  }, [setTitleEditing, fireItemChanged]);


  const resetTitleKInfo = useCallback(async (folderPath, keyName) => clearTitleKInfo(folderPath, keyName).then(fireItemChanged), [clearTitleKInfo, fireItemChanged]);

  const resetValueEditing = useCallback(async (folderPath, keyName) => setValueEditing(folderPath, keyName, false).then(fireItemChanged), [setValueEditing, fireItemChanged]);
  const resetValueKInfo   = useCallback(async (folderPath, keyName) => clearValKInfo(folderPath, keyName).then(fireItemChanged), [clearValKInfo, fireItemChanged]);

  const tagKeyEditing   = useCallback(async (folderPath, keyName) => setKeyEditing(folderPath, keyName).then(fireItemChanged), [setKeyEditing, fireItemChanged]);  
  const clearKeyKInfo = useCallback(async (folderPath, keyName) => resetKeyKInfo(folderPath, keyName, false).then(fireItemChanged), [resetKeyKInfo, fireItemChanged]);

  // TODO: return memoizedValue ?

  return {
    itemChanged,
    configKeyCreated, clearErrorKeyCreated,  tagCreateKeyInProgress, resetCreateKeyInProgress, tagKeyEditing, tagKeyLocked, resetKeyLocked, clearKeyKInfo,
    tagValueLocked, resetValueLocked, tagValueEditing, resetValueEditing, resetValueKInfo,
    tagTitleLocked, resetTitleLocked, tagTitleEditing, resetTitleKInfo,
    reasoning, setReasoning, insightRejected, setInsightRejected
  }
}
